import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Friends = ({ googleAccessToken }) => {
    const [friendsList, setFriendsList] = useState([]);

    useEffect(() => {
        const fetchFriends = async () => {
            try {
                const response = await axios.get('https://your-api.com/friends', {
                    headers: {
                        'Authorization': `Bearer ${googleAccessToken}`,
                    },
                });
                setFriendsList(response.data);
            } catch (error) {
                console.error('Error fetching friends:', error);
            }
        };

        if (googleAccessToken) {
            fetchFriends();
        }
    }, [googleAccessToken]);

    return (
        <div className="friends-widget">
            <h2>Your Friends</h2>
            <ul>
                {friendsList.map((friend) => (
                    <li key={friend.id}>{friend.name}</li>
                ))}
            </ul>
        </div>
    );
};

export default Friends;
